import { useState, useMemo, } from "react"
import { useUI } from "providers/UIProvider"

import { Flex, Text, Select as ChakraSelect } from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import CarNumberBox from "components/UI/molecules/CarNumberBox"
import Modal from "components/UI/organisms/Modal"
import { UI_INITIAL_CONTEXT } from "providers/UIProvider/UIProviderConstants"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { AxiosResponse } from "axios"
import reservationsService from "api/reservationsService"
import { toast } from "react-toastify"
import moment from "moment"



const CarOnPlaceModal = () => {
  const { modals, toggleModal, T } = useUI();
  const { reservationIdsToUpdate, verifiedBoxAssignInfo, setState, isAuthenticated } = useAppContext();
  const { onDeny } = modals.carOnPlaceModal.data
  const [selectedBoxes, setSelectedBoxes] = useState([]);

  useMemo(async () => {
    if (isAuthenticated) {
      const filteredReservationIds: number[] = [...new Set(reservationIdsToUpdate)]
      const verifyCall = await reservationsService.verifyQueueReservations(filteredReservationIds)
      const verifiedData = verifyCall.data

      setState({ verifiedBoxAssignInfo: verifiedData })
    }
  }, [reservationIdsToUpdate])


  const handleClose = () => {
    toggleModal("carOnPlaceModal", false, UI_INITIAL_CONTEXT.modals.carOnPlaceModal.data)
    const request = indexedDB.open("qapp-firebase-messages", 1);
    request.onsuccess = (event: any) => {
      const db = event.target.result;
      const tx = db.transaction("messages", "readwrite");
      const store = tx.objectStore("messages");
      store.openCursor().onsuccess = async function (event: any) {
        const cursor = event.target.result;
        if (cursor) {
          await cursor.delete();
          setSelectedBoxes([])
          cursor.continue();
        }
      };
    };

    if (onDeny) onDeny()
  }
  const handleSubmit = async () => {
    if (selectedBoxes !== undefined && Object.keys(selectedBoxes).length === verifiedBoxAssignInfo?.data.length) {
      const formattedData: any = Object.entries(selectedBoxes).map((e: any) => {
        return { "reservationId": e[0], box: e[1] };
      });

      const res: any = await reservationsService.changeBulkReservationBox(formattedData);
      if (res.status === 200) {

        const request = indexedDB.open("qapp-firebase-messages", 1);
        request.onsuccess = (event: any) => {
          const db = event.target.result;
          const tx = db.transaction("messages", "readwrite");
          const store = tx.objectStore("messages");
          store.openCursor().onsuccess = async function (event: any) {
            const cursor = event.target.result;
            if (cursor) {
              await cursor.delete();
              cursor.continue();
            }
          };
        };
        toggleModal("carOnPlaceModal", false, { title: "" })
        setState({ reservationIdsToUpdate: null, verifiedBoxAssignInfo: null })
        setSelectedBoxes([])
      }
      ///deleteMessages
    }
  }

  return (
    <Modal
      isOpen={modals["carOnPlaceModal"]?.isOpened ?? false}
      onClose={handleClose}
      styles={{
        width: "650px",
        bodyPadding: "28px 20px",
      }}
      closeOnOverlayClick={false}
    >
      <Flex style={{ flexDirection: "column", gap: 15 }}>
        <Flex style={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Text style={{ fontWeight: "bold", fontSize: "20px" }}>{T("notifications.car_on_place.title")}</Text>
        </Flex>
        {
          verifiedBoxAssignInfo?.data?.map((info: any) => {

            return <Flex key={info.reservationId} style={{ flexDirection: "row", height: "40%", justifyContent: "space-around", alignItems: "flex-start" }}>
              <Flex style={{
                flexDirection: "row",
                height: "3.563rem",
                width: "18.375rem",
                justifyContent: "space-around",
                alignItems: "center",
                gap: 2,
                marginTop: "22px",
                backgroundColor: "#E9F2FD",
                borderRadius: "16px"
              }}>
                <Text style={{ fontSize: "16px", color: "#7D90A8" }}>{`${T("caronplace.modal.reservation.time")}:`}</Text>
                <Text style={{ fontSize: "20px", color: "#000514", fontWeight: "550" }}>{moment(info.startDateTime).format("DD/MM - HH:mm")}</Text>
              </Flex>
              <Flex style={{ display: "flex", flexDirection: "column" }}>
                <Text mb="10px">{info?.vehicleMark} {info?.vehicleModel} ({info?.vehicleBodyType})</Text>
                <CarNumberBox height="40px" width="8.5rem" title={info.vehicleGovNumber} />
              </Flex>
              <Flex style={{ display: "flex", flexDirection: "column" }}>
                <Text fontSize="base" mb="13px" mt="3px">{T("notifications.car_on_place.form.select_box")}</Text>
                <ChakraSelect
                  style={{ width: "7.5rem", height: "2.5rem" }}
                  value={selectedBoxes[info.reservationId]}
                  onChange={async (e: any) => {
                    const boxNumber: number = parseInt(e.target.value);
                    const res: AxiosResponse<any> =
                      await reservationsService.getCheckboxAvailability(info.reservationId, boxNumber);
                    const updatedSelectedBoxes: any = { ...selectedBoxes };
                    // If the box is taken but it  car is not being washed
                    const hasWarning: boolean = res.data?.data?.warning ?? false;
                    // If the box is taken but it the car is being washed
                    const hasError: boolean = res.data?.data?.error ?? false;
                    const hasValidationError: boolean = Object.values(updatedSelectedBoxes).some((e: any) => e === boxNumber) ?? false;

                    updatedSelectedBoxes[info.reservationId] = boxNumber;


                    if (hasValidationError) {
                      toast.error(T("caronplace.box.choose.error"))
                      return
                    }


                    if (hasWarning) {

                      toggleModal(
                        "confirmationModal",
                        true,
                        {
                          title: `${T("are.you.sure")} ${boxNumber} ${T("change.box")}`,
                          handleSubmit: () => {
                            setSelectedBoxes(updatedSelectedBoxes)
                            toggleModal("confirmationModal", false, { title: "" })
                          }
                        }
                      )
                      return;
                      // If denied pass () => {}
                      // If accepted
                      //const updatedSelectedBoxes: any = { ...selectedBoxes };
                      // If CheckBoxAvailability returns no warning or errors change the value 
                      // updatedSelectedBoxes[info.reservationId] = e.value;
                      // setSelectedBoxes(updatedSelectedBoxes);
                    }
                    if (hasError) {
                      toast.error(T("general.error"))
                      console.log("Error for box");
                      return;

                    }

                    // // If CheckBoxAvailability returns no warning or errors change the value 
                    setSelectedBoxes(updatedSelectedBoxes);
                  }}
                // options={generateOptions(info?.boxCount || 0)}

                >
                  <option value={0}>{"No Box"}</option>
                  {Array(info?.boxCount).fill(0).map((option: any, index: number) => {
                    return <option key={index} value={index + 1}>#{index + 1}</option>;
                  })}
                </ChakraSelect>
              </Flex>
            </Flex>
          })
        }
        {/* <Flex style={{ flexDirection: "row", height: "40%", justifyContent: "space-evenly", alignItems: "flex-start" }}>
          <Flex style={{ display: "flex", flexDirection: "column" }}>
            <Text mb="10px">{boxAssignInfo?.vehicleMark} {boxAssignInfo?.vehicleModel} ({boxAssignInfo?.vehicleBodyType})</Text>
            <CarNumberBox title={boxAssignInfo?.vehicleGovNumber} />
          </Flex>
          <Flex style={{ display: "flex", flexDirection: "column" }}>
            <Text fontSize="base" mb="10px">{T("notifications.car_on_place.form.select_box")}</Text>
            <Select
              value={selectedBox}
              onChange={(e: ISelectOption) => setSelectedBox(e.value)}
              options={generateOptions(boxAssignInfo?.boxCount || 0)}
            />
          </Flex>
        </Flex>
        <Flex style={{ flexDirection: "row", height: "40%", justifyContent: "space-evenly", alignItems: "flex-start" }}>
          <Flex style={{ display: "flex", flexDirection: "column" }}>
            <Text mb="10px">{boxAssignInfo?.vehicleMark} {boxAssignInfo?.vehicleModel} ({boxAssignInfo?.vehicleBodyType})</Text>
            <CarNumberBox title={boxAssignInfo?.vehicleGovNumber} />
          </Flex>
          <Flex style={{ display: "flex", flexDirection: "column" }}>
            <Text fontSize="base" mb="10px">{T("notifications.car_on_place.form.select_box")}</Text>
            <Select
              value={selectedBox}
              onChange={(e: ISelectOption) => setSelectedBox(e.value)}
              options={generateOptions(boxAssignInfo?.boxCount || 0)}
            />
          </Flex>
        </Flex> */}
        <Flex style={{ justifyContent: "space-around" }} padding="0 10px" paddingTop="40px">
          <Button
            text={T("actions.confirm")}
            isDisabled={selectedBoxes.length === 0}
            _hover={{ backgroundColor: "#08BA36" }}
            onClick={handleSubmit}
            variant="success"
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
            styles={{ width: "180px", height: "55px", fontSize: "m" }}
          />
          <Button
            text={T("actions.deny")}
            onClick={handleClose}
            variant="error"
            leftIcon={
              <Icon
                name="close_rounded"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
            styles={{ width: "180px", height: "55px", fontSize: "m" }}
          />

        </Flex>
      </Flex>
    </Modal>
  )
}

export default CarOnPlaceModal
